import { gql } from '@apollo/client'
import fullObjectivePaymentFragment from '../objectivePayments/fullObjectivePayment.fragment'
import fullObjectiveFragment from './ObjectiveDTO.fragment'

export const OBJECTIVE_DTO_LIST = gql`
  query ObjectivesDtoList($employeeId: HashedId!, $employeeResigned: Boolean = false) {
    objectivesDtoList(employeeId: $employeeId, employeeResigned: $employeeResigned) {
      ...fullObjectiveFragment
    }
  }
  ${fullObjectiveFragment}
`
export const OBJECTIVE_DTO_LIST_AND_EMPLOYEE_CONTRACT = gql`
  query objectiveListAndEmployeeContract($employeeId: HashedId!, $employeeResigned: Boolean = false) {
    objectivesDtoList(employeeId: $employeeId, employeeResigned: $employeeResigned) {
      ...fullObjectiveFragment
    }
    resignedContract(employeeId: $employeeId) @include(if: $employeeResigned) {
      id
      currencyForPayments
    }
    currentContract(employeeId: $employeeId) @skip(if: $employeeResigned) {
      id
      currencyForPayments
    }
  }
  ${fullObjectiveFragment}
`

export const OBJECTIVES_IN_MEETING = gql`
  query ObjectivesInMeeting($meetingId: HashedId!) {
    objectivesInMeeting(meetingId: $meetingId) {
      ...fullObjectiveFragment
    }
    objectivePayment: objectivePaymentByMeeting(id: $meetingId) {
      ...FullObjectivePayment
    }
  }
  ${fullObjectiveFragment}
  ${fullObjectivePaymentFragment}
`

export const OBJECTIVES_WITH_ATTACHMENTS_FROM_MEETING = gql`
  query objectivesWithAttachmentsFromMeeting($meetingId: HashedId!) {
    objectivesWithAttachmentsFromMeeting(meetingId: $meetingId) {
      globalId
      attachment
      attachmentDownloadToken
    }
  }
`

export const EXISTING_DEV_TARGETS_TO_BE_CLOSED = gql`
  query existingDevObjectivesToBeClosedInMeeting($meetingId: HashedId!) {
    existingDevObjectivesToBeClosedInMeeting(meetingId: $meetingId)
  }
`
